import {
  Heart, Video, ShoppingBag, Home, Briefcase, GraduationCap, UtensilsCrossed,
} from "lucide-react";

export const MODULES = [
  {
    key: "love", name: "Pula Love", tagline: "Safe Connections", path: "/love",
    icon: Heart, color: "#E07A5F",
    image: "https://images.unsplash.com/photo-1781145854391-a49446a1d19b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxjb3VwbGUlMjBsYXVnaGluZyUyMG91dGRvb3JzfGVufDB8fHx8MTc4NDUzNjQyMXww&ixlib=rb-4.1.0&q=85",
    short: "Safe connections for all genders & identities. Women free forever · men £10/month — no other charges, keeping everyone protected.",
  },
  {
    key: "live", name: "Pula Live", tagline: "Real Live Moments", path: "/live",
    icon: Video, color: "#81B29A",
    image: "https://images.pexels.com/photos/6670747/pexels-photo-6670747.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    short: "Real live moments. No viewer counts, no ads, no vanity metrics.",
  },
  {
    key: "food", name: "Pula Food", tagline: "Fair · Heritage", path: "/food",
    icon: UtensilsCrossed, color: "#4A5D23",
    image: "https://images.unsplash.com/photo-1760907949894-b66d728e0a8e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
    short: "Order from family-run kitchens — they keep ~95%, you pay them directly. Heritage honoured, small restaurants first.",
  },
  {
    key: "market", name: "Pula Market", tagline: "Fair Trade", path: "/market",
    icon: ShoppingBag, color: "#E9C46A",
    image: "https://images.pexels.com/photos/33337889/pexels-photo-33337889.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    short: "Buy, sell and rent — 0% commission · £0 listing fees. Premium features optional.",
  },
  {
    key: "properties", name: "Pula Properties", tagline: "Homes & Land", path: "/properties",
    icon: Home, color: "#4A5D23",
    image: "https://images.pexels.com/photos/2371974/pexels-photo-2371974.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    short: "£0 commission ever. Far cheaper than typical UK property portals.",
  },
  {
    key: "jobs", name: "Pula Jobs", tagline: "Fair Work", path: "/jobs",
    icon: Briefcase, color: "#81B29A",
    image: "https://images.pexels.com/photos/7495104/pexels-photo-7495104.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    short: "100% free for job seekers. Employer checks rolling out.",
  },
  {
    key: "learn", name: "Pula Learn", tagline: "Free Skills", path: "/learn",
    icon: GraduationCap, color: "#E07A5F",
    image: "https://images.unsplash.com/photo-1616769364512-1e50e8266907?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxzdHVkZW50JTIwbGVhcm5pbmclMjBsYXB0b3AlMjBzbWlsZXxlbnwwfHx8fDE3ODQ1MzY0MjJ8MA&ixlib=rb-4.1.0&q=85",
    short: "Free forever — from basic reading to AI, construction and business. Certificates included. For you, your children, your future.",
  },
];

export const IMAGES = {
  hero: "https://images.pexels.com/photos/7551181/pexels-photo-7551181.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  logo: "https://images.pexels.com/photos/8879925/pexels-photo-8879925.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  portal: "https://images.unsplash.com/photo-1762341118954-d0ce391674d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjB3b3JraW5nJTIwZGVza3xlbnwwfHx8fDE3ODQ1MzY0MzJ8MA&ixlib=rb-4.1.0&q=85",
};

export const DISCLAIMER =
  "Pula and Mavula Investment are not banks or immigration authorities. We connect people fairly — always use qualified legal and financial professionals for official matters.";
